import { OTHER_OPTION_ID } from '@seek/job-category';

// OTHER_OPTION_ID: -1
// hirer has selected other category radio option
// but hasn't selected any value from dropdown list

export const isSubCategoryIdValid = (categoryId?: number | null) =>
  typeof categoryId === 'number' &&
  categoryId > 0 &&
  categoryId !== OTHER_OPTION_ID;
